<template>
    <v-container fluid class="pa-6">
        <div class="d-flex flex-wrap align-center justify-space-between ga-3 mb-4">
            <div>
                <h2 class="text-h6">Zone</h2>
                <div class="text-body-2 text-medium-emphasis">Preventivi e valore per zona (IVA esclusa)</div>
            </div>
            <filtro-periodo />
        </div>

        <v-alert v-if="nonAssegnata && nonAssegnata.quota >= 10" type="info" variant="tonal" density="compact"
            class="mb-4">
            {{ formatPerc(nonAssegnata.quota) }} del valore ({{ formatNumero(nonAssegnata.n) }} preventivi) non ha una
            zona assegnata.
        </v-alert>

        <v-row>
            <v-col cols="12" md="5">
                <v-card variant="outlined" :loading="caricamento" class="h-100">
                    <v-card-title>Quota di valore per zona</v-card-title>
                    <v-card-text>
                        <div v-if="zone.length" style="height: 320px">
                            <Doughnut :data="datiGrafico" :options="opzioniGrafico" />
                        </div>
                        <div v-else-if="!caricamento" class="text-medium-emphasis">Nessun preventivo nel periodo.</div>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" md="7">
                <v-card variant="outlined" :loading="caricamento" class="h-100">
                    <v-card-title>Dettaglio</v-card-title>
                    <v-card-text v-if="zone.length">
                        <v-table density="compact">
                            <thead>
                                <tr>
                                    <th>Zona</th>
                                    <th class="text-right">Preventivi</th>
                                    <th class="text-right">Valore</th>
                                    <th class="text-right">Valore medio</th>
                                    <th class="text-right">% valore</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="z in zone" :key="z.zona">
                                    <td>{{ z.zona }}</td>
                                    <td class="text-right">{{ formatNumero(z.n) }}</td>
                                    <td class="text-right">{{ formatEuro(z.valore) }}</td>
                                    <td class="text-right">{{ formatEuro(z.valoreMedio) }}</td>
                                    <td class="text-right">{{ formatPerc(z.quota) }}</td>
                                </tr>
                            </tbody>
                        </v-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { Doughnut } from "vue-chartjs";
import { COLORI, PALETTE } from "@/utils/chart.js";
import Functions from "@/utils/functions.js";
import periodo from "@/mixins/periodo.js";
import FiltroPeriodo from "@/components/statistiche/FiltroPeriodo.vue";

export default {
    name: "ZonePage",
    components: { FiltroPeriodo, Doughnut },
    mixins: [periodo],

    data() {
        return {
            zone: [],
            caricamento: false,
        };
    },

    computed: {
        nonAssegnata() {
            return this.zone.find((z) => z.zona === "Non assegnata");
        },

        datiGrafico() {
            // "Non assegnata" sempre in grigio, le zone vere con i colori della palette.
            let i = 0;
            return {
                labels: this.zone.map((z) => z.zona),
                datasets: [{
                    data: this.zone.map((z) => z.valore),
                    backgroundColor: this.zone.map((z) =>
                        z.zona === "Non assegnata" ? COLORI.grigio : PALETTE[i++ % PALETTE.length]),
                }],
            };
        },

        opzioniGrafico() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { position: "bottom" },
                    tooltip: {
                        callbacks: {
                            label: (ctx) => ctx.label + ": " + Functions.formatEuro(ctx.parsed),
                        },
                    },
                },
            };
        },
    },

    methods: {
        formatEuro: Functions.formatEuro,
        formatNumero: Functions.formatNumero,
        formatPerc: Functions.formatPerc,

        async carica() {
            this.caricamento = true;
            const periodoRichiesto = this.periodo;
            try {
                const dati = await this.$store.dispatch("statistiche/zone");
                if (periodoRichiesto === this.periodo) this.zone = dati;
            } catch (error) {
                console.log(error);
            }
            this.caricamento = false;
        },
    },
};
</script>
